<template>
  <div class="kpi mt-3">
    <v-card class="custom_card" background="#fff">
      <!-- Header -->
      <v-layout class="header pa-4" align-center>
        <v-flex shrink class="mb-n5">
          <v-img
            eager
            width="80"
            height="80"
            :src="require('../../assets/images/dashboard/building-head.png')"
          ></v-img>
        </v-flex>
        <v-flex shrink style="color: #fff">
          <div class="font-24 font-w-700">NSP BUILDING ECOSYSTEMS</div>
          <div class="font-16 font-w-700">30 DECEMBER 2023</div>
        </v-flex>
      </v-layout>
      <!-- body -->
      <div class="pa-6">
        <!-- Section 1 -->
        <div class="d-flex">
          <!-- ผลกระทบทางเศรษฐกิจ -->
    
          <v-flex xs6 class="pa-4" >
            <div
              class="d-flex align-items-center justify-space-between"
              style="height: 100%"
            >
              <div class="">
                <div class="font-24 font-w-700">COMPANIES/</div>
                <div class="font-24 font-w-700">ORGANIZATIONS</div>
              </div>
              <div
                style="
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  width: 24%;
                "
              >
                <v-img
                  style="background-size: contain; background-position: center"
                  width="auto"
                  height="auto"
                  :src="require('../../assets/images/dashboard/company.png')"
                ></v-img>
              </div>
              <div class="companies_organization position-relative"
              :style="{
            fontSize: `${chartData?.companies_organizations?.toString().length === 1 || chartData?.companies_organizations?.toString().length === 2 
              ? 118 
              : chartData?.companies_organizations?.toString().length === 3 
                ? 92 
                : 72}px`,
  }"
                            
              >

              {{ formatNumber(chartData?.companies_organizations, 0) }}
                <!-- {{ chartData?.companies_organizations ?? '0' }} -->
              </div>
            </div>
          </v-flex>

          <!-- มูลค่าการลงทุนเพิ่มใน R & D -->
          <v-flex xs3 class="pl-6 con_rd">
            <div class="d-flex gap-4 ">
              <div class="font-20 font-w-700">FROM</div>
              <div class="chip-text ml-1 "  style='background-color: var(--theme-color-one);margin-top: 5px;'>
                {{ formatNumber(chartData?.total_creations, 0) }}

              </div>
            </div>
            <div></div><div class="font-20 font-w-700">TOTAL JOB CREATIONS</div>
            <div
              class="d-flex justify-center align-items-center"
              style="height: 80%"
            >
              <div class="rd">            
                {{ formatNumber(chartData?.total_creations, 0) }}
              </div>
              <div class="people-rd ml-1" style="height: 100%">
                <div class="">PEOPLE</div>
                <div class="">R&D PERSONAL</div>
              </div>
            </div>

            <v-img
              style="position: absolute; bottom: 20px; left: 24px"
              width="22%"
              max-width="100"
              height="auto"
              :src="require('../../assets/images/dashboard/job-creation.png')"
            ></v-img>
          </v-flex>

          <!-- คะแนนความพึงพอใจรวม -->
          <v-flex xs3 style="position: relative;"
           class="pl-6">
            <div class="font-20 font-w-700" style="height:30px;">ECONOMIC IMPACT &</div>
            <div class="font-20 font-w-700"  style="height:30px;">SOCIAL CONTRIBUTIONS</div>
            <div
              class="d-flex justify-center align-items-center"
              style="height: 80%"
            >
              <v-img
                style="position: absolute; bottom: 20px; left: 24px"
                width="20%"
                max-width="100"
                height="auto"
                :src="require('../../assets/images/dashboard/eco.png')"
              ></v-img>
              <div
                class="sec-number ml-15"
                style="color: var(--theme-color-one)"
              >
              {{ formatNumber(chartData?.economic_impact_social, 0) }}

              </div>
            </div>
          </v-flex>
        </div>

        <v-divider style="border-width: 1px" />

        <!-- Section 2 -->
        <v-layout class="">
          <!-- จำนวนผลิตภัณฑ์/บริการใหม่ -->
          <v-flex
            xs3
            class=""
            style="display: flex; flex-direction: column; height: 672px"
          >
            <!-- subsection -->
            <div class="d-flex flex-column pa-4" style="height: 33%">
              <div class="d-flex gap-4">
                <div class="font-22 font-w-700">ORGANIZATIONS</div>
              </div>
              <div
                class="d-flex justify-center align-end"
                style="height: 100%; position: relative"
              >
                <v-img
                  style="position: absolute; bottom: 20px; left: 0px"
                  width="25%"
                  max-width="100"
                  height="auto"
                  :src="
                    require('../../assets/images/dashboard/organization.png')
                  "
                ></v-img>
                <div class="sec-number ml-8" style="color: var(--theme-color-five);font-size: 75px;">
              {{ formatNumber(chartData?.organizations_percentage, 0) }}%
                  
                </div>
              </div>
            </div>
            <!-- end  subsection -->
            <v-divider style="border-width: 1px" />

            <div class="d-flex flex-column pa-4 " style='width: 100%; height: 100%; overflow: hidden;'>
              <div class="font-16 font-w-700">พื้นที่ผู้ให้บริการ</div>
              <div class='d-flex gap-4 py-2 mt-4'>
                  <span class="circle-dot" style="background-color: #F9BB43; "></span> 
                  <span class='gray-text'>Unit ที่ให้บริการแล้ว</span>
              </div>
              <div class='d-flex gap-4 py-2'>

                  <span class="circle-dot" style="background-color: #F7941D; "></span> 
                  <span class='gray-text'>พื้นที่ที่ให้บริการแล้ว</span>
              </div>
              <div class='d-flex gap-4 py-2'>
                  <span class="circle-dot" style="background-color: #EFEFEF; "></span> 
                  <span class='gray-text'>พื้นที่ว่าง</span>
              </div>
              <div>

                <Donut :options="chartOptions2" type='2' ></Donut>
              </div>
            </div>
          </v-flex>
          <!-- ร้อยละผู้ใช้บริการ -->
          <v-flex
            xs9
            class=""
            style="
              border-left: 2px solid #d3d3d3;
              display: flex;
              flex-direction: column;
              height: 672px;
            "
          >
            <div class="d-flex" style="width: 100%; height: 66.66%">
              <div
                class="pa-4 d-flex"
                style="width: 66.66%; border-right: 2px solid #d3d3d3"
              >
                <div class=""  style="width: 100%;  height: 100%">
                  <div class="d-flex pa-4 flex-column">
                    <div class="d-flex  justify-center responsive-chart" >
                    
                      <div class="">
                        <div class="font-20  font-w-700" >
                        สัดส่วนผู้ใช้บริการ
                      </div>
                      <div class='d-flex gap-4 py-1 mt-4'>
                  <span class="circle-dot" style="background-color: #E86551; "></span> 
                  <span class='gray-text'>Direct R&D</span>
              </div>
              <div class='d-flex gap-4 py-1'>

                  <span class="circle-dot" style="background-color: #F9BB43; "></span> 
                  <span  class='gray-text'>R&D Support</span>
              </div>
              <div class='d-flex gap-4 py-1'>
                  <span class="circle-dot" style="background-color: #D3D3D3; "></span> 
                  <span  class='gray-text'>Strategic Partners</span>
              </div>
              <div class='d-flex gap-4 py-1'>
                <div>
                  <span class="circle-dot" style="background-color: #EFEFEF; "></span> 
                </div>
                  <span  class='gray-text'>Ecosystem Supporting Facilities</span>
              </div>
              </div>
                      <Donut  :options="chartOptions1" type="1"></Donut>
                    </div>
                  </div>
                </div>
                <div class=""></div>
              </div>
              <div
                class="d-flex flex-column"
                style="width: 33.33%; height: 100%"
              >
                <div
                  class="d-flex flex-column pa-4"
                  style="
                    height: 100%;
                    width: 100%;
                    border-bottom: 2px solid #d3d3d3;
                  "
                >
                  <div class="mt-5 font-20 font-w-700">ACTIVITIES</div>
                  <div class="chip-text mt-2" style='background-color: var(--theme-color-one);'>FDV 67 =                          {{ formatNumber(chartData?.activities_fy, 0) }}

                  </div>

                  <div
                    class="d-flex justify-center align-end"
                    style="height: 100%; position: relative"
                  >
                    <v-img
                      style="position: absolute; bottom: 0; left: 0px"
                      width="95px"
                      max-width="100"
                      height="auto"
                      :src="
                        require('../../assets/images/dashboard/activity.png')
                      "
                    ></v-img>
                    <div
                      class="sec-number ml-10"
                      style="color: var(--theme-color-one)"
                    >
                    {{ formatNumber(chartData?.activities_fy, 0) }}

                    </div>
                  </div>
                </div>
                <div
                  class="d-flex flex-column pa-4"
                  style="height: 100%; width: 100%"
                >
                <div class="mt-5 font-20 font-w-700">ORGANIZATIONS</div>
  
                <div class="chip-text mt-2" style='background-color: var(--theme-color-one);'>FDV 67 =                    {{ formatNumber(chartData?.organizations_fy, 0) }}

                </div>
                  <div
                    class="d-flex justify-center align-end"
                    style="height: 100%; position: relative"
                  >
                    <v-img
                      style="position: absolute; bottom: 0; left: 0px"
                      width="95px"
                      max-width="100"
                      :src="
                        require('../../assets/images/dashboard/map-organ.png')
                      "
                    ></v-img>
                    <div
                      class="sec-number ml-10"
                      style="color: var(--theme-color-one)"
                    >
                    {{ formatNumber(chartData?.organizations_fy, 0) }}

                    </div>
                  </div>
                </div>
              </div>
            </div>
            <v-divider style="border-width: 1px" />
            <v-layout class="" style="height: 33.33%; width: 100%">
              <div
                class="d-flex flex-wrap justify-space-between"
                style="width: 100%"
              >
                <v-row class="d-flex flex-wrap pa-3" style="width: 100%">
                  <v-col
                    v-for="(info, index) in bottomDataFiltered"
                    :key="info.name"
                    cols="auto"
                    class="d-flex "
                    :style="{
                        flex: `0 0 ${100 / bottomDataFiltered.length}%`,
                        maxWidth: `${100 / bottomDataFiltered.length}%`,
                        borderRight: index !== (bottomDataFiltered.length-1) ? '2px solid #d3d3d3' : ''
                      }"
                    >
                    <div
                      class="d-flex flex-column"
                      style="height: 100%; width: 100%"
                    >
                      <div class="d-flex gap-4">
                        <div class="font-16 font-w-700 bottom-section-header"
                        :style="{
                            fontSize: `${Math.max(50 - 4 * bottomDataFiltered.length, 16)}px`,
                            height: `${28 + 4 * bottomDataFiltered.length}px`, // Dynamic height
                          }"
                        >{{ info.name }}</div>
                      </div>
                      <div
                        class="d-flex "
                        style="height: 100%; margin-top: 20px;"
                      >
                      <div
                        class="d-flex justify-center align-end"
                        style="height: 100%; position: relative"
                      >
                        <v-img
                          style="
                            position: absolute;
                            bottom: -8px;
                            left: 12px;
                            width: 90px;
                            max-width: 110px;
                          "
                         :src="require(`../../assets/images/dashboard/${info.img}`)"
                        ></v-img>
                      </div>
                        <div
                          class="ter-number"
                          style="color: var(--theme-color-eleven);"
                        >
                        {{ formatNumber(info?.value, 0) }}%
                        </div>
                      </div>
                  
                    </div>
                  </v-col>
                </v-row>
              </div>
            </v-layout>
          </v-flex>
        </v-layout>
      </div>
    </v-card>
  </div>
</template>

<script>
import * as XLSX from "xlsx";
import moment from "moment";
import Donut from "./Donut.vue";
import { Chart } from "highcharts-vue";
import Highcharts from "highcharts";
import HighchartsMore from "highcharts/highcharts-more";
import {formatNumber } from "@/plugins/global-funcs";

export default {
  name: "KPI",
  components: { Donut },
  props: {
    filter: {
      type: Object,
      default: () => ({
        plan_id: "",
        region_id: "",
        year: "",
      }),
    },
    exportExcel: {
      type: Boolean,
      default: false,
    },
    region: {
      type: Array,
      default: () => [],
    },
  },
  data() {
   
    return {
    chartData: {
      companies_organizations:null,
      
    },
    formatNumber,

    bottomData: [
      {
        name: "IT SOFTWARE AND DIGITAL CONTENT",
        img: "ITsoftware.png",
        key:''
      },
      {
        name: "AGRICULTURE AND FOOD",
        img: "agri.png",
        key:'sum_food'
      
      },
      {
        name: "ENERGY TECH AND MATERIAL",
        img: "energy2.png",
        key:'sum_materials'
      
      },
      {
        name: "MEDICAL AND BIO-TECH",
        img: "med.png",
        key:'sum_medical'
      
      },
      {
        name: "HEALTH AND WELLNESS",
        img: "health.png",
        key:''
      
      },
      {
        name: "LOGISTIC",
        img: "truck.png",
        key:''
      
      },
      {
        name: "OTHER",
        img: "others.png",
        key:'sum_other'

      },
    ],
    bottomDataFiltered: [],

    userData:[],
    subData:[],
    chartOptions1: {
        chart: {
          type: "pie",
        },
        title: {
          text: null,
        },
        subtitle: {
          text: null,
        },
        plotOptions: {
          pie: {
            shadow: false,
            center: ["50%", "42%"],
          },
        },

        legend: {
        layout: 'vertical',
        align: 'right',
        verticalAlign: 'middle'
        },
        series: [
          {
            name: "",
            data: [],
            size: "64%",
            innerSize: "48%", 
            dataLabels: {
              color: "#ffffff",
              style: {
                    color: '#ffffff',
                    textOutline: 'none',
                    fontWeight: 'normal'
                },
              
              distance: -25,
              connectorWidth: 0,
              formatter: function () {
                console.log('testetst',this.point.name)
                  const isGray = this.point.name.includes('ESF') || this.point.name.includes('RDS');
                  return `<span style="color: ${isGray ? '#9b9b9b' : '#ffffff'};">
                              <div style='font-weight:700;'>${this.point.name}</div>`;
              }
            },
          },
          {
            name: "",
            data: [],
            size: "100%",
            innerSize: "67%",
            dataLabels: {
              allowOverlap: true,
              color: "#ffffff",
              style: {
                    color: '#ffffff',
                    textOutline: 'none',
                    fontWeight: 'normal'
                },
              distance: -25,
              connectorWidth: 0,
              
              formatter: function () {
                    const isGray = this.point.MainProject.includes('ESF') || this.point.MainProject.includes('RDS');
                    const isPartner = this.point.MainProject === 'PARTNER' || this.point.MainProject.includes('ESF'); // Check if MainProject is 'PARTNER'
                    
                    const color = isPartner ? '#ffffff' : (isGray ? '#9b9b9b' : '#ffffff');

                    return `<span style="color: ${color};">
                                <div style='font-weight:700;'>${this.point.name}</div>
                            </span>`;
                  }
            },
          
            id: "versions",
          },
        ],
        responsive: {
          rules: [
            {
              condition: {
                maxWidth: 400,
              },
              chartOptions: {
                series: [
                  {},
                  {
                    id: "versions",
                    // dataLabels: {
                    //   distance: 10,
                    //   format: "{point.custom.version}",
                    //   filter: {
                    //     property: "percentage",
                    //     operator: ">",
                    //     value: 2,
                    //   },
                    // },
                  },
                ],
              },
            },
          ],
        },
      },
      chartOptions2: {
        chart: {
          type: "pie",
        },
        title: {
          text: null,
        },
        subtitle: {
          text: null,
        },
        plotOptions: {
          pie: {
            shadow: false,
            center: ["40%", "40%"],
          },
        },
        tooltip: {
          valueSuffix: "%",
        },
        legend: {
            enabled: true,
            align: "center", 
            verticalAlign: "bottom", 
            layout: "horizontal",
            itemStyle: {
            fontWeight: "bold", 
            color: "#333",
            },
        },
        series: [
          {
            name: "",
            data: [
              { name: "Unit ที่ให้บริการแล้ว", y: 0, color: "#F9BB43" },
              { name: "Unit ว่าง", y: 0, color: "#EFEFEF" },
             
            ],
            size: "55%",
            innerSize: "50%", 
            dataLabels: {
              allowOverlap: true,
              color: "#ffffff",
              style: {
                    color: '#ffffff',
                    textOutline: 'none',
                    fontWeight: 'normal',
                    fontSize: '7px'
                },
              distance: -16,
              connectorWidth: 0,
              formatter: function () {
                if (this.point.name === "Unit ที่ให้บริการแล้ว") {
                  return this.point.name; 
                } else {
                  return null; 
                }
              },
            },
          },
          {
            name: "",
            data: [
              { name: "พื้นที่ที่ให้บริการแล้ว", y: 0, color: "#F7941D" },
              { name: "พื้นที่ว่าง", y: 0, color: "#EFEFEF" },
          
            ],
            size: "90%",
            innerSize: "65%",
            dataLabels: {
              allowOverlap: true,
              color: "#ffffff",
              style: {
                    color: '#ffffff',
                    textOutline: 'none',
                    fontWeight: 'normal',
                    fontSize: '7px'
                },
              distance: -16,
              connectorWidth: 0,
              formatter: function () {
                if (this.point.name === "พื้นที่ที่ให้บริการแล้ว") {
                  return this.point.name; 
                } else {
                  return null; 
                }
              },
            },
          },
        ],
        responsive: {
          rules: [
            {
              condition: {
                maxWidth: 400,
              },
              chartOptions: {
                series: [
                  {},
                  {
                    id: "versions",
                    // dataLabels: {
                    //   distance: 10,
                    //   format: "{point.custom.version}",
                    //   filter: {
                    //     property: "percentage",
                    //     operator: ">",
                    //     value: 2,
                    //   },
                    // },
                  },
                ],
              },
            },
          ],
        },
    },
}
},
  watch: {
    filter: {
      handler: function (val) {
        this.getData();
      },
      deep: true,
    },
    exportExcel: function (val) {
      if (val) {
        this.exportToExcel();
      }
    },
  },
  created() {
    this.getData();
  },
  methods: {
    async getData() {

      let res = await this.$apiFire("Dashboard/building", this.filter);
      if (res) {
        console.log('res', res);
        this.chartData = res;
        this.chartData.chart_data_user = JSON.parse(res.chart_data_user);
        this.chartData.chart_data_area = JSON.parse(res.chart_data_area);
         // console.log('chart', this.chartData.chart_data_area);
        // console.log('chart', this.chartData.chart_data_user);

        this.mapFirstChart()
        this.mapSecondChart()
        const max =  (this.chartData.sum_ict+
          this.chartData.sum_food+
          this.chartData.sum_science+ 
          this.chartData.sum_materials+ 
          this.chartData.sum_electronics+ 
          this.chartData.sum_medical+ 
          this.chartData.sum_auto+ 
          this.chartData.sum_other
        )
        const sumArray = [
        Math.round((this.chartData.sum_ict / max) * 100),
           Math.round((this.chartData.sum_food / max) * 100),
          Math.round(
            (
              (this.chartData.sum_science / max) +
              (this.chartData.sum_materials / max) +
              (this.chartData.sum_electronics / max)
            ) * 100
          ),
          Math.round((this.chartData.sum_medical / max) * 100),
          Math.round(0), 
          Math.round((this.chartData.sum_auto / max) * 100),
          Math.round((this.chartData.sum_other / max) * 100),
        ];
        // console.log('sumArray', sumArray);  

        this.bottomData = this.bottomData.map((item, index) => ({
          ...item, 
          value: sumArray[index], 
        }));
        this.bottomDataFiltered = this.bottomData.filter((item) => item.value > 0);
       

       
      }
    },
    mapFirstChart(){
        const categories = ["RDS", "R&D", "PARTNER", "ESF"];
        const areaData = this.chartData.chart_data_area?.chart_data_area || {};
        const getCategoryData = (key, color, drilldownName) => {
        const area = areaData[key] || {};
        const subCategories = ["l", "m", "s", "startup"];

        const mappedData = subCategories.map((subKey) => ({
          name: subKey.toUpperCase(),
          value: area[subKey] ?? 0,
        }));

        const smCategory = mappedData.filter(item => item.name === 'S' || item.name === 'M')
                                      .reduce((acc, curr) => {
                                        acc.value += curr.value; 
                                        return acc;
                                      }, { name: 'SM', value: 0 });

        const filteredData = mappedData
          .filter(item => item.value > 0 && !(item.name === 'S' || item.name === 'M')) 
          .concat(smCategory);

        return {
          y: filteredData.reduce((acc, { value }) => acc + value, 0),
          color,
          drilldown: {
            name: drilldownName,
            categories: filteredData.map((item) => item.name),
            data: filteredData.map((item) => item.value),
          },
        };
      };


          const data = [
                          getCategoryData("rds", "#D3D3D3", "Strategic Partners"),
                          getCategoryData("rd", "#E86551", "R&D"),
                          getCategoryData("partner", "#F9BB43", "PARTNER"),
                          getCategoryData("esf", "#EFEFEF", "Ecosystem Supporting Facilities"),
                        ].filter((item) => item.y !== 0); 
                        console.log(data,'data')
          data[2].drilldown.color = '#ffffff'
          data[3].drilldown.color = '#ffffff'
        this.chartOptions1.series[0].data = [];
        this.chartOptions1.series[1].data = [];
      

        data.forEach((item, index) => {
          // console.log(item, index, 'item');

          this.chartOptions1.series[0].data.push({
            name: categories[index],
            y: item.y,
            color: item.color,
          });

          item.drilldown.categories.forEach((cat, j) => {
            const brightness = 0.2 - (j / item.drilldown.data.length) / 5;
            const drilldownColor =
              item.color === "#D3D3D3"
                ? "#DFDFDF"
                : item.color === "#EFEFEF"
                ? "#ffffff"
                 : item.color === "#F9BB43"
                ? "#ffffff"
                : Highcharts.color(item.color).brighten(brightness).get();

            this.chartOptions1.series[1].data.push({
              name: (categories[index] === 'ESF' || categories[index] === 'PARTNER') ?  '' : cat,
              y: item.drilldown.data[j],
              color: drilldownColor,
              custom: {
                cat: cat.split(" ")[1] || cat.split(" ")[0],
              },
              MainProject: categories[index],
            });
          });
        });
    },
    mapSecondChart(){
      this.chartOptions2.series[0].data[0].y = this.chartData.chart_data_user.chart_data_user.area_used;
      this.chartOptions2.series[0].data[1].y = this.chartData.chart_data_user.chart_data_user.area_left;
      this.chartOptions2.series[1].data[0].y = this.chartData.chart_data_user.chart_data_user.unit_used;
      this.chartOptions2.series[1].data[1].y = this.chartData.chart_data_user.chart_data_user.unit_left;
      console.log(this.chartOptions2,'jjj')
    },
   
    checkFormatNummber(number) {
      if (!number) return 0;
      number = parseFloat(number).toFixed(1);
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    exportToExcel() {
      const workbook = XLSX.utils.book_new();
      const worksheet = XLSX.utils.json_to_sheet([]);

      // ส่วนหัวข้อ งบประมาณ
      let doc_date = moment().add(543, "year").format("DDMMYYYY");
      const topicRow = [
        "KPI/KRI ตัวชี้วัดผลการดำเนินงานของอุทยานวิทยาศาสตร์ภูมิภาค (Key Performance Indicators: KPIs)",
        "ข้อมูล ณ วันที่ " + doc_date,
      ];
      XLSX.utils.sheet_add_aoa(worksheet, [topicRow], { origin: "A1" });

      let jsonExcelSection1 = [];
      jsonExcelSection1.push({
        ลำดับ: 1,
        ภูมิภาค: this.filter.region_id
          ? this.region.find((e) => e.id == this.filter.region_id)?.name
          : "ทั้งหมด",
        "ปี งปม.": this.filter.year ? this.filter.year : "ทั้งหมด",
        ผลกระทบทางเศรษฐกิจของผู้ประกอบการรวมต่อปี: this.checkFormatNummber(
          this.data.economyEconomy
        ),
        "มูลค่าการลงทุนเพิ่มใน R&D ของผู้ใช้บริการต่อปี":
          this.checkFormatNummber(this.data.RDInvestValue),
        คะแนนความพึงพอใจรวมของผู้ใช้บริการโดยเฉลี่ยทุกแผนงานรายปี:
          this.checkFormatNummber(this.data.totalSatisfiedScore),
        "จำนวนผลิตภัณฑ์/บริการใหม่ที่เสนอขายในตลาดต่อปี":
          this.checkFormatNummber(this.data.productAmount),
        ร้อยละผู้ใช้บริการที่เพิ่มขึ้นต่อปี: this.checkFormatNummber(
          this.data.userServicePercent
        ),
        "อัตราผลตอบแทนจากการลงทุน ROI": this.checkFormatNummber(
          this.data.rateOfReturn
        ),
        ร้อยละของรายได้รวมที่เพิ่มขึ้นต่อปี: this.checkFormatNummber(
          this.data.totalIncomeRate
        ),
        ผลประกอบการต่องบประมาณ: this.checkFormatNummber(
          this.data.turnoverPerBudget
        ),
        ร้อยละของรายได้จากการถ่ายทอดเทคโนโลยีที่เพิ่มขึ้นต่อปี:
          this.checkFormatNummber(this.data.technologyIncomeRate),
        การจ้างงานรวมต่อปี: this.checkFormatNummber(this.data.totalHireAmount),
        ระดับการพัฒนากระบวนการภายในของอุทยานฯ: this.data.developmentAmount,
        ระดับของการสร้างความตะหนักถึงการมีอยู่ของอุทยานฯในพื้นที่และการสร้างชื่อเสียงให้แก่อุทยานฯ:
          this.data.realizeAmount,
        "สัดส่วนงานวิจัย IP ที่ถ่ายทอดต่อจำนวนงานวิจัยIP พร้อมใช้ในปี":
          this.checkFormatNummber(this.data.ipResearchRate),
        จำนวนนิติบุคคลใหม่ที่จัดตั้งภายใต้อุทยานฯต่อปี: this.checkFormatNummber(
          this.data.newJuristic
        ),
      });

      XLSX.utils.sheet_add_json(worksheet, jsonExcelSection1, {
        origin: "A2",
      });

      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet 1");
      let fileName = `KPI_dashboard_${doc_date}.xlsx`;
      XLSX.writeFile(workbook, fileName);

      this.$emit("clearExportExcel", false);
    },
  },
};
</script>

<style lang="scss">
.kpi {
  .v-progress-circular__overlay {
    stroke-linecap: round;
  }

  .custom_card {
    border-radius: 20px;
    .header {
      background: linear-gradient(0deg, #f15a29 6.18%, #fbb040 84.83%);
    }
  }

  .companies_organization {
    font-weight: 700;
    font-size: 128px;
    color: #f19782;
    font-family: "Poppins";
    height: 100%;
    margin-right: 24px;
    display: flex;
    // align-items: flex-end;
    align-items: center;
  }
  .con_rd {
    border-left: 2px solid #d3d3d3;
    border-right: 2px solid #d3d3d3;
    position: relative;
    .rd {
      position: relative;
      display: flex;
      align-items: center;
      margin-left: 36px;
      font-weight: 700;
      font-size: 56px;
      color: var(--theme-color-one);
      font-family: "Poppins";
      text-align: center;
    }
    .people-rd {
      position: relative;
      display: flex;
      justify-content: center;
      flex-direction: column;
      color: var(--theme-color-eight);
      font-weight: 500;
      font-size: 14px;
      font-family: "Poppins";
      text-align: left;
    }
  }

  .satisfaction_score {
    position: relative;
    font-family: "Poppins";
    font-style: normal;
    font-weight: 700;
    font-size: 76px;
    color: #f7941d;
    margin-bottom: -2rem;
    padding-left: 14px;
    padding-top: 8px;
  }
  .new_product {
    font-family: "Poppins";
    font-weight: 700;
    font-size: 76px;
    text-align: center;
    color: #f9bb43;
  }
}
.txt_orange {
  color: #f7941d;
}
.txt_green {
  color: #216957;
}
.txt_blue {
  color: #3b608a;
}
.font-pp {
  font-family: "Poppins";
}
.chip-text {
  font-size: 12px;
  font-weight:500;
  color: #fff;
  border-radius: 50px;
  width: max-content;
  height: max-content;
  display: flex;
  justify-content: center;
  text-align: center;
  align-items: center;
  padding: 0px 12px;
}
.sec-number {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 700;
  font-size: 60px;
  font-family: "Poppins";
  text-align: center;
}
.ter-number {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 700;
  font-size: 45px;
  font-family: "Poppins";
  text-align: center;
  margin-bottom: 30px;
}
.circle-dot {
  width: 14px;
  margin-top: 3px;
  height: 14px; 
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 24px; 
}
.gray-text{
  color:var(--theme-color-eight)
}
@media only screen and (max-width: 1331px) {
  .ter-number {
    margin-bottom: 0 !important;
  }
}

@media only screen and (max-width: 768px) {
  .ter-number {
    font-size: 40px !important; /* ลดเล็กน้อยเฉพาะ tablet */
    margin-bottom: 0 !important;
  }

  /* Responsive header text for bottom section */
  .bottom-section-header {
    font-size: 14px !important;
    height: auto !important;
  }
}

@media only screen and (max-width: 1600px) {
  .con_rd {
    .rd {
      font-size: 50px;
      margin-left: 20px !important;
    }
    .people-rd {
      font-size: 12px !important;
    }
  }
}
@media only screen and (min-width: 1600px) {
  .responsive-chart{
  gap:112px;
}

}
@media only screen and (min-width: 1920px) {
  .responsive-chart{
  gap:144px;
}

}
</style>
